import { CostBudgetType } from '@eapproval/offer-shared'
import { getQuotationDetailExcelColumnIds } from './VendorUploadQuotationDetailSection/quotationTeamplateDetailColumns'

const getZZ6ByCategory = (category, zzz6Entries = []) => {
  if (!category || !Array.isArray(zzz6Entries)) {
    return ''
  }

  const matchingZZZ6 = zzz6Entries.find((zzz6) => {
    const categories = Array.isArray(zzz6?.Category) ? zzz6.Category : []
    return categories.includes(category)
  })

  return matchingZZZ6?.ZZ6 || ''
}

const getDefaultCategoryByCostBudgetType = (costBudgetType, zzz6Entries = []) => {
  let defaultCategory = ''

  switch (costBudgetType) {
    case CostBudgetType.SUPPLY_ENGINEERING_SERVICE:
      defaultCategory = 'General Electrical Installation'
      break
    case CostBudgetType.SUPPLY_MAINTENANCE_SERVICE:
      defaultCategory = 'Maintenance Building'
      break
    default:
      break
  }

  const defaultSAPMaterialNumber = getZZ6ByCategory(defaultCategory, zzz6Entries)

  return {
    defaultCategory,
    defaultSAPMaterialNumber,
  }
}

export const createDefaultQuotationDetailRow = (costBudgetType, zzz6Entries = []) => {
  const tableColumns = getQuotationDetailExcelColumnIds(costBudgetType)
  const { defaultCategory, defaultSAPMaterialNumber } = getDefaultCategoryByCostBudgetType(costBudgetType, zzz6Entries)

  const newRow = {
    ...tableColumns.reduce((acc, cur) => {
      acc[cur] = ''
      return acc
    }, {}),
    ECCNDetail: [
      {
        description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_2',
        selected: false,
        productName: '',
      },
      {
        description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_3',
        selected: false,
        productName: '',
      },
      {
        description: 'VENDOR_UPLOAD_PAGE_QUESTIONNAIRE_BASIC_QUERY_4',
        selected: false,
        productName: '',
      },
    ],
  }

  if (defaultCategory && Object.prototype.hasOwnProperty.call(newRow, 'category')) {
    newRow.category = defaultCategory
  }

  if (defaultSAPMaterialNumber && Object.prototype.hasOwnProperty.call(newRow, 'SAPMaterialNumber')) {
    newRow.SAPMaterialNumber = defaultSAPMaterialNumber
  }

  return newRow
}
